import { MapPin, Clock, Star } from "lucide-react";
import { Badge } from "./ui/badge";
import { Button } from "./ui/button";

const PackageCard = ({ pkg, onViewDetails }) => {
  const categoryColors = {
    luxury: "bg-secondary-500 text-white",
    premium: "bg-primary-700 text-white",
    standard: "bg-muted text-foreground"
  };

  return (
    <div 
      className="group relative overflow-hidden rounded-md shadow-md hover:shadow-2xl transition-all duration-500 bg-white"
      data-testid={`package-card-${pkg.id}`}
    >
      {/* Image */}
      <div className="relative h-48 overflow-hidden">
        <img 
          src={pkg.image_url || "https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=800"} 
          alt={pkg.title}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
        
        {/* Badges */}
        <div className="absolute top-3 left-3 flex gap-2">
          <Badge className={categoryColors[pkg.category] || categoryColors.standard}>
            {pkg.category}
          </Badge>
          {pkg.is_featured && (
            <Badge className="bg-secondary-500 text-white">
              <Star className="w-3 h-3 mr-1" /> Featured
            </Badge>
          )}
        </div>
        
        {/* Price */}
        <div className="absolute bottom-3 right-3">
          <span className="bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-primary-700 font-bold text-sm">
            ₹{pkg.price?.toLocaleString()}
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="p-5">
        <h3 className="font-heading text-xl font-semibold text-foreground mb-2 group-hover:text-primary-700 transition-colors">
          {pkg.title}
        </h3>
        
        <div className="flex items-center gap-4 text-muted-foreground text-sm mb-3">
          <span className="flex items-center gap-1">
            <MapPin className="w-4 h-4" />
            {pkg.destination}
          </span>
          <span className="flex items-center gap-1">
            <Clock className="w-4 h-4" />
            {pkg.duration}
          </span>
        </div>
        
        <p className="text-muted-foreground text-sm line-clamp-2 mb-4">
          {pkg.description}
        </p>

        {/* Highlights */}
        <div className="flex flex-wrap gap-2 mb-4">
          {pkg.highlights?.slice(0, 3).map((h, i) => (
            <span key={i} className="text-xs bg-primary-50 text-primary-700 px-2 py-1 rounded">
              {h}
            </span>
          ))}
        </div>

        <Button 
          onClick={() => onViewDetails?.(pkg)}
          className="w-full bg-primary-700 hover:bg-primary-900"
          data-testid={`view-package-${pkg.id}`}
        >
          View Details
        </Button>
      </div>
    </div>
  );
};

export default PackageCard;
